<template>
  <v-row v-if="mutableModel">
    <v-col cols="2" class="mt-4" v-if="fieldOption.help_text">
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="mr-2" v-bind="attrs"
                  v-on="on">mdi-help-circle
          </v-icon>
        </template>
        <span>{{ fieldOption.help_text }}</span>
      </v-tooltip>
    </v-col>
    <v-col class="pb-0">
      <v-row v-if="fieldType==='color'">
        <v-col cols="4" class="mt-4">
          <span>
        {{ fieldOption.label }}
          </span>
        </v-col>
        <v-col class="float-right">
          <v-color-picker mode="hexa" :autofocus="index===0" color="primary"
                          v-model="mutableModel[fieldOption.name]">
          </v-color-picker>
          <v-btn size="small" @click="$emit('change')" color="primary">Apply</v-btn>
        </v-col>
      </v-row>

      <v-text-field v-if="fieldType==='textfield'"
                    v-model="mutableModel[fieldOption.name]"
                    @change="$emit('change')"
                    :type="textFieldType"
                    color="primary"
                    :rules="rules"
                    :filled="filled"
                    :label="fieldOption.label"
                    :autofocus="index===0"
      ></v-text-field>

      <v-textarea :filled="filled" :label="fieldOption.label" color="primary" :rules="rules"
                  v-model="mutableModel[fieldOption.name]" :autofocus="index===0"
                  v-if="fieldType==='textarea'" @change="$emit('change')"></v-textarea>

      <v-row v-if="fieldType==='image'">
        <v-col cols="4" class="mt-4"
        >
          <span>
        {{ fieldOption.label }}
          </span>
        </v-col>
        <v-col class="float-right">
          <v-file-input
              :autofocus="index===0"
              :filled="filled"
              accept="image/png, image/jpeg"
              v-model="file"
              prepend-icon=""
              @change="mutableModel[fieldOption.name] =  file; $emit('change') "
              color="primary"
          >
            <template v-slot:prepend-inner>
              <v-tooltip right top v-if="file">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="mr-3"
                  >
                    mdi-image
                  </v-icon>
                </template>
                <v-img
                    :src="file.name"
                    style="border-radius:5px"
                    max-width="300px"
                >
                </v-img>
              </v-tooltip>
              <v-icon
                  v-else

                  class="mr-3"
              >
                mdi-image
              </v-icon>
            </template>
          </v-file-input>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>


<script>
import fieldConfiguration from '../../config/config'
import FieldRulesMixin from "@/mixins/FieldRulesMixin.vue";
import {RHDHVWorkOrderField} from "@haskoning/vue-component-library";


export default {
  name: 'FieldRHDHV',
  components: {RHDHVWorkOrderField},
  mixins: [FieldRulesMixin],
  props: {
    fieldOption: {required: true},
    model: {required: true},
    index: {required: true},
    filled: {
      default: false,
      required: false
    },
    dialog: {
      default: false,
      required: false
    }
  },
  data: () => ({
    field: {},
    file: null,
    password: false,
    mutableModel: null
  }),
  watch: {
    async dialog(newValue) {
      if (newValue) {
        await this.setImageFile()
      }
    }
  },
  computed: {
    textFieldType: function () {
      if (this.password) {
        return 'password'
      } else if (this.fieldOption.type === 'integer') {
        return 'number'
      } else {
        return 'text'
      }
    },
    fieldType: function () {
      if (this.fieldOption.field_type && this.fieldOption.field_type === 'color') {
        return 'color'
      }
      let property = this.fieldOption['max_length'];
      let fieldConfig = fieldConfiguration[this.fieldOption['type']]
      return fieldConfig[property] || fieldConfig["default"]
    },
  },
  methods: {
    async setImageFile() {
      if (this.model[this.fieldOption.name] && this.fieldType === 'image') {
        this.file = new File([], this.model[this.fieldOption.name], {type: "image/png;jpeg"});
      }
    },
  },
  async mounted() {
    this.mutableModel = this.model
    if (!this.mutableModel[this.fieldOption.name]) {
      this.mutableModel[this.fieldOption.name] = this.fieldOption.default ? this.fieldOption.default : null;
    }
    if (this.fieldOption.field_type && this.fieldOption.field_type === 'password') {
      this.password = true
    }
    await this.setImageFile()
  }


}
</script>
